var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('Loader'):(_vm.item)?_c('EXCMCarUserDataForm',{attrs:{"closeModal":_vm.closeModal,"handle-submit":_vm.onSendForm,"handle-update-field":_vm.updateField,"values":_vm.item,"errors":_vm.violations,"initial-values":_vm.retrieved}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }